<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item name="2" v-if="chartOption.tooltip.show">
        <template slot="title">
          <div class="verticallyCenter spaceBetween width100">
            <span>提示框字段匹配</span><span @click.stop="addMatchFunc" class="icon-portal-plus-small right_font"></span>
          </div>
        </template>
        <!--<div class="data-item verticallyCenter">
      <span class="mr12 fs14">显示列数</span>
      <el-input type="number" v-model="formatterColumn" class="w100_70">
        <template slot="suffix">
          <span class="suffix_text">列</span>
        </template>
      </el-input>
    </div>-->
        <div class="match-list" v-for="(rich, key) in matchLists" :key="key">
          <collapsibleItem
            :key="key"
            :name="'data' + key"
            :type="rich.title"
            :is-active="collapse[rich.title].isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, key)"
          >
            <div slot="heading" class="verticallyCenter title-box fs14">
              <p>字段设置{{ key + 1 }}</p>
              <div class="icon_set">
                <span @click.stop="copyRchMatch(rich, key)" class="icon-portal-copy mr8" />
                <span @click.stop="delRchMatch(rich, key)" class="icon-portal-delete" />
              </div>
            </div>
            <div slot="body">
              <div class="single_bg mt8 mlD16">
                <div class="data-item">
                  <span class="font14 mr8">展示类型</span>
                  <el-radio-group v-model="rich.type">
                    <el-radio label="1">文本</el-radio>
                    <el-radio label="2">图片</el-radio>
                  </el-radio-group>
                </div>
                <div class="" v-if="rich.type === '1'">
                  <cx-select class="mt16" :selectOptions="dataTypeLists" :value.sync="rich.name" />
                  <div class="data-item mt16">
                    <div>
                      <cx-check-box :value.sync="rich.boxWidthPercent">宽度使用百分比</cx-check-box>
                      <slider-and-input
                        v-if="rich.boxWidthPercent"
                        title="宽"
                        class="mt8"
                        :value.sync="rich.boxWidth"
                        :sliderMax="100"
                        suffix="%"
                      />
                      <slider-and-input
                        v-else
                        title="宽"
                        class="mt8"
                        :value.sync="rich.boxWidth"
                        :sliderMax="maxWidth"
                        suffix="px"
                      />
                    </div>
                    <div class="mt16">
                      <cx-check-box :value.sync="rich.boxHeightPercent">高度使用百分比</cx-check-box>
                      <slider-and-input
                        v-if="rich.boxHeightPercent"
                        title="高"
                        class="mt8"
                        :value.sync="rich.boxHeight"
                        :sliderMax="100"
                        suffix="%"
                      />
                      <slider-and-input
                        v-else
                        title="高"
                        class="mt8"
                        :value.sync="rich.boxHeight"
                        :sliderMax="maxHeight"
                        suffix="px"
                      />
                    </div>
                  </div>
                  <div class="data-item mt16">
                    <!-- 字体和颜色/字重和字号 -->
                    <text-setting-update
                      class="nextlinemt8"
                      :fontColor.sync="rich.fontColor"
                      :fontFamily.sync="rich.fontFamily"
                      :fontSize.sync="rich.fontSize"
                      :fontWeight.sync="rich.fontWeight"
                    />
                  </div>
                  <div class="data-item mt16 item-label-mr4">
                    <span class="font14 mr8">位置</span>
                    <el-radio-group v-model="rich.align">
                      <el-radio label="left">居左</el-radio>
                      <el-radio label="center">居中</el-radio>
                      <el-radio label="right">居右</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="data-item mt16">
                    <cx-padding
                      :paddingTypeFlag.sync="rich.paddingTypeFlag"
                      :padding.sync="rich.padding"
                      :paddingTop.sync="rich.paddingTop"
                      :paddingRight.sync="rich.paddingRight"
                      :paddingBottom.sync="rich.paddingBottom"
                      :paddingLeft.sync="rich.paddingLeft"
                    />
                  </div>
                  <!--外边距-->
                  <div class="data-item mt16">
                    <cx-padding
                      paddingName="外边距"
                      :paddingTypeFlag.sync="rich.marginTypeFlag"
                      :padding.sync="rich.margin"
                      :paddingTop.sync="rich.marginTop"
                      :paddingRight.sync="rich.marginRight"
                      :paddingBottom.sync="rich.marginBottom"
                      :paddingLeft.sync="rich.marginLeft"
                    />
                  </div>
                  <div class="data-item mt16">
                    <!--提示框背景颜色-->
                    <color-picker class="bg-width" :color.sync="rich.backgroundColor" title="背景颜色" />
                  </div>
                  <div class="data-item mt16">
                    <cx-check-box :value.sync="rich.showIcon">显示图标</cx-check-box>
                    <div v-show="rich.showIcon">
                      <div class="data-item mt16">
                        <img-upload-simple :imgSrc.sync="rich.iconImg" />
                      </div>
                      <div class="data-item mt16">
                        <double-input
                          title="尺寸"
                          placeHolderText="必填"
                          :value1.sync="rich.iconWidth"
                          :value2.sync="rich.iconHeight"
                          :inputSuffixs="['宽', '高']"
                        />
                      </div>
                      <div class="data-item mt16">
                        <cx-padding
                          paddingName="内边距"
                          :paddingTypeFlag.sync="rich.iconMarginTypeFlag"
                          :padding.sync="rich.iconMargin"
                          :paddingTop.sync="rich.iconMarginTop"
                          :paddingRight.sync="rich.iconMarginRight"
                          :paddingBottom.sync="rich.iconMarginBottom"
                          :paddingLeft.sync="rich.iconMarginLeft"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="data-item mt16">
                    <cx-check-box :value.sync="rich.showLabel">显示字段名</cx-check-box>
                    <div v-show="rich.showLabel">
                      <text-setting-update
                        class="mt8"
                        :fontColor.sync="rich.labelFontColor"
                        :fontFamily.sync="rich.labelFontFamily"
                        :fontSize.sync="rich.labelFontSize"
                        :fontWeight.sync="rich.labelFontWeight"
                      />
                      <p class="mt16">字段名和内容间距</p>
                      <slider-and-input
                        class="mt8"
                        :value.sync="rich.labelMargin"
                        :sliderMax="rich.boxWidth"
                        suffix="px"
                      />
                    </div>
                  </div>
                  <div class="data-item mt16">
                    <cx-check-box :value.sync="rich.showUnit">显示单位</cx-check-box>
                    <div v-show="rich.showUnit">
                      <div class="mt16">
                        <span class="font14 mr10 half-label">文字内容</span>
                        <el-input
                          class="width-half-bigWidth el-input el-input--suffix"
                          placeholder="请输入"
                          v-model="rich.unitValue"
                        >
                        </el-input>
                      </div>
                      <text-setting-update
                        class="mt8"
                        :fontColor.sync="rich.unitFontColor"
                        :fontFamily.sync="rich.unitFontFamily"
                        :fontSize.sync="rich.unitFontSize"
                        :fontWeight.sync="rich.unitFontWeight"
                      />
                      <p class="mt16">单位和内容间距</p>
                      <slider-and-input
                        class="mt8"
                        :value.sync="rich.unitMargin"
                        :sliderMax="rich.boxWidth"
                        suffix="px"
                      />
                    </div>
                  </div>
                </div>
                <div class="" v-if="rich.type === '2'">
                  <cx-select class="mt16" title="" :selectOptions="dataTypeLists" :value.sync="rich.name" />
                  <div class="data-item mt16">
                    <div>
                      <cx-check-box :value.sync="rich.boxWidthPercent">宽度使用百分比</cx-check-box>
                      <slider-and-input
                        v-if="rich.boxWidthPercent"
                        title="宽"
                        class="mt8"
                        :value.sync="rich.boxWidth"
                        :sliderMax="100"
                        suffix="%"
                      />
                      <slider-and-input
                        v-else
                        title="宽"
                        class="mt8"
                        :value.sync="rich.boxWidth"
                        :sliderMax="maxWidth"
                        suffix="px"
                      />
                    </div>
                    <div class="mt16">
                      <cx-check-box :value.sync="rich.boxHeightPercent">高度使用百分比</cx-check-box>
                      <slider-and-input
                        v-if="rich.boxHeightPercent"
                        title="高"
                        class="mt8"
                        :value.sync="rich.boxHeight"
                        :sliderMax="100"
                        suffix="%"
                      />
                      <slider-and-input
                        v-else
                        title="高"
                        class="mt8"
                        :value.sync="rich.boxHeight"
                        :sliderMax="maxHeight"
                        suffix="px"
                      />
                    </div>
                  </div>
                  <div class="data-item mt16 item-label-mr4">
                    <span class="font14 mr8">位置</span>
                    <el-radio-group v-model="rich.align">
                      <el-radio label="left">居左</el-radio>
                      <el-radio label="center">居中</el-radio>
                      <el-radio label="right">居右</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="content-item mt16">
                    <slider-and-input
                      class="mt16"
                      :value.sync="rich.borderRadius"
                      title="圆角"
                      :sliderMax="100"
                      suffix="px"
                    />
                  </div>
                  <div class="data-item mt16">
                    <cx-padding
                      :paddingTypeFlag.sync="rich.paddingTypeFlag"
                      :padding.sync="rich.padding"
                      :paddingTop.sync="rich.paddingTop"
                      :paddingRight.sync="rich.paddingRight"
                      :paddingBottom.sync="rich.paddingBottom"
                      :paddingLeft.sync="rich.paddingLeft"
                    />
                  </div>
                </div>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex"
export default {
  components: {
    widthAndSizeAndZindex
  },
  data() {
    return {
      activeNames: ["2"],
      dataTypeLists: [],
      matchLists: [], //匹配字段的列表
      collapseDataActiveNames: [],
      collapse: {}, // 用来存放当前数据组的展开收起状态
      maxWidth: 100,
      maxHeight: 100
    }
  },
  props: {
    options: Object,
    datas: Array,
    mapType: String
  },
  watch: {
    datas(newVal, oldVal) {
      if (JSON.parse(JSON.stringify(newVal)) !== JSON.parse(JSON.stringify(oldVal))) {
        this.init()
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    chartOption() {
      return this.options.chartOption
    },
    formatterColumn: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.formatterColumn", "tooltip.formatterColumn", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.formatterColumn", false)
      }
    }
  },
  methods: {
    init() {
      if (this.datas.length > 0) {
        this.dataTypeLists = []
        for (let key in this.datas[0]) {
          // itemStyle用于指定当前数据的样式，不参于提示框的字段匹配
          if (key !== "itemStyle") {
            this.dataTypeLists.push({
              label: key,
              value: key
            })
          }
        }
      }
      if (this.mapType === "hotMap") {
        if (this.chartOption.visualMap.dataFormatter && this.chartOption.visualMap.dataFormatter.length > 0) {
          this.matchLists = this.chartOption.visualMap.dataFormatter
        }
      } else if (this.mapType === "scatterMap") {
        if (this.chartOption.scatter.dataFormatter && this.chartOption.scatter.dataFormatter.length > 0) {
          this.matchLists = this.chartOption.scatter.dataFormatter
        }
      }
      this.maxWidth = this.chartOption.tooltip.tooltipWidth || 100
      this.maxHeight = this.chartOption.tooltip.tooltipHeight || 100
      if (this.matchLists.length > 0) {
        this.matchLists.forEach(item => {
          this.collapse[item.title] = {
            isActive: false
          }
        })
      }
    },
    //新增字段匹配
    addMatchFunc() {
      if (this.mapType === "hotMap") {
        this.dataTypeLists = []
        if (this.chartOption.visualMap.data.length > 0) {
          for (let key in this.chartOption.visualMap.data[0]) {
            if (key !== "itemStyle") {
              this.dataTypeLists.push({
                label: key,
                value: key
              })
            }
          }
        }
      } else if (this.mapType === "scatterMap") {
        this.dataTypeLists = []
        if (this.chartOption.scatter.data.length > 0) {
          for (let key in this.chartOption.scatter.data[0]) {
            if (key !== "itemStyle") {
              this.dataTypeLists.push({
                label: key,
                value: key
              })
            }
          }
        }
      }
      let titleRandom = Math.floor(Math.random() * 10000) + ""
      this.collapse[titleRandom] = {
        isActive: false
      }
      let newFormatter = {
        type: "1",
        boxWidthPercent: true,
        boxWidth: 100, //列宽百分比
        boxHeightPercent: false,
        boxHeight: 10, //列高
        name: this.dataTypeLists[0].label,
        align: "center",
        fontColor: "rgba(255,255,255,1)",
        fontFamily: "sans-serif",
        fontSize: 12,
        fontWeight: "normal",
        paddingTypeFlag: 1,
        padding: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        showLabel: true,
        labelFontColor: "rgba(255,255,255,1)",
        labelFontFamily: "sans-serif",
        labelFontSize: 12,
        labelFontWeight: "normal",
        labelMargin: 0,
        showUnit: false,
        unitValue: "",
        unitFontColor: "rgba(255,255,255,1)",
        unitFontFamily: "sans-serif",
        unitFontSize: 12,
        unitFontWeight: "normal",
        unitMargin: 0,
        showIcon: false,
        iconImg: "",
        iconWidth: 10,
        iconHeight: 10,
        iconMarginTypeFlag: 1,
        iconMargin: 0,
        iconMarginTop: 0,
        iconMarginRight: 0,
        iconMarginBottom: 0,
        iconMarginLeft: 0,
        borderRadius: 0,
        backgroundColor: "rgba(0,0,0,1)",
        marginTypeFlag: 1,
        margin: 0,
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        title: titleRandom
      }
      this.matchLists.push(newFormatter)
      let arr = this.matchLists
      if (this.mapType === "hotMap") {
        this.$changeOptionsEV(arr, `chartOption.visualMap.dataFormatter`, false, false, false, true)
      } else if (this.mapType === "scatterMap") {
        this.$changeOptionsEV(arr, `chartOption.scatter.dataFormatter`, false, false, false, true)
      }
    },
    delRchMatch(rich, key) {
      this.matchLists.splice(key, 1)
      for (let item in this.collapse) {
        if (item == rich.title) {
          delete this.collapse[item]
        }
      }
      if (this.mapType === "hotMap") {
        this.$changeOptionsEV(this.matchLists, `chartOption.visualMap.dataFormatter`, false, false, false, true)
      } else if (this.mapType === "scatterMap") {
        this.$changeOptionsEV(this.matchLists, `chartOption.scatter.dataFormatter`, false, false, false, true)
      }
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    //复制字段匹配
    copyRchMatch(rich, key) {
      let newRich = Object.assign({}, rich),
        num = Math.floor(Math.random() * 10000) + ""
      newRich.title = num
      this.matchLists.push(newRich)

      this.collapse[num] = {
        isActive: false
      }
      let arr = this.matchLists
      if (this.mapType === "hotMap") {
        this.$changeOptionsEV(arr, `chartOption.visualMap.dataFormatter`, false, false, false, true)
      } else if (this.mapType === "scatterMap") {
        this.$changeOptionsEV(arr, `chartOption.scatter.dataFormatter`, false, false, false, true)
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>
.w100_70 {
  width: calc(100% - 70px);
}
.spaceBetween {
  justify-content: space-between;
}
.width100 {
  width: 100%;
}
.single_bg {
  position: relative;
  border: 1px solid #313336;
  border-radius: 4px;
  padding: 12px;
}
.single_bg .icon_set {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 24px;
  height: 24px;
  top: 1px;
  right: 1px;
  background: #363a40;
  cursor: pointer;
}
.item-label-mr4 .el-radio {
  margin-right: 4px;
}
::v-deep.bg-width .color-picker-container {
  width: calc(100% - 70px);
}
.title-box {
  justify-content: space-between;
  width: 100%;
}
.mlD16 {
  margin-left: -16px;
}
.collapsible-item .item-heading span.mr8 {
  margin-right: 8px;
}
</style>
